import React from 'react';
import Header1 from './Header1';

const Header = ({ page_name, cover }) => {

    return (<Header1 page_name={page_name} cover={cover} />);
};

export default Header;
